import Vue, {createApp} from 'vue'
import App from './App.vue'
import Vuex from "vuex";
import store  from './store'
import moment from 'moment';

Vue.config.productionTip = false
//Vue.http.headers.common['Access-Control-Allow-Origin'] = 'http://127.0.0.1:6543'
//Vue.http.headers.common['Access-Control-Request-Method'] = '*'
/*
new Vue({
  render: h => h(App)
}).$mount('#app')
*/
const app = createApp(App)

app.use(Vuex)
// app.use(VueHead)
app.use(store)
app.mount('#app')

app.config.globalProperties.$filters = {
    currency(value) {
        return '$' + value.toFixed(2)
    },
    formatDate(value) {
        if (value) {
            // eslint-disable-next-line
            console.log("formatDate...")
            return moment(String(value)).format('YYYY-MM-DD')
        }
        return "";
    },
    formatDateTime(value) {
        if (value) {
            return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
        }
        return "";
    },
    formatExpenseIncomeAccounts(value) {
        if (!value) {
            return '';
        }
        if (value.endsWith('EXPENSE')) {
            return '(virtuelles Ausgabenkonto)';
        }
        if (value.endsWith('INCOME')) {
            return '(virtuelles Einnahmenkonto)';
        }
        return value;
    },
    cleanId(id) {
        if (Array.isArray(id)) {
            // eslint-disable-next-line
            console.log("cleanId: " + id)
            return id[1];
        } else {
            return id;
        }
    },
    formatBalance(amount) {
        let num = Number(amount / 100);
        return parseFloat(Math.round(num * 100) / 100)
            .toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }
}